<template>
    
        <div class="modal-view" v-if="isShow">
            <transition name="modal-bounce">
                <div class="content w-80">
                    <div class="header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            @click="hide"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <p class="title mb-0">點擊地圖點位，並按下確認，標示Gps位置</p>
                    </div>
                    <div class="body pb-4">
                        <div class="map-view mb-4">
                            <GMapMap
                                :center="mapCenter"
                                :zoom="15"
                                style="width: 100%; height: 100%;"
                                @click="handleMapClick"
                            >
                                <GMapMarker
                                    v-if="clickedLocation"
                                    :position="clickedLocation"
                                />
                            </GMapMap>
                        </div>
                        <div v-if="clickedLocation">
                            <button class="btn btn-primary w-100"
                                @click="select"
                            >
                                緯度:{{ clickedLocation.lat }} , 經度:{{ clickedLocation.lng }} 確認使用此位置？
                            </button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
</template>
  
<script>
import {  GMapMap, GMapMarker } from '@fawmi/vue-google-maps';
export default {
    name:'mapView',
    props:[],
    data(){
        return {
            isShow:false,
            clickedLocation:null,
            mapCenter: { lat: 23.10909935905703, lng: 121.19934015581916 } // 默認中心 野灣動物醫院院址 23.10909935905703, 121.19934015581916
        }
    },
    components: {
        GMapMap,
        GMapMarker
    },
    methods:{
        show(){
            this.isShow = true
            // this.getCurrentLocation();
        },
        hide(){
            this.isShow = false
        },
        handleMapClick(event){
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            this.clickedLocation = { lat, lng };
            this.$debug('Clicked location:', { lat, lng });
        },
        getCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    this.mapCenter = { lat, lng };
                }, error => {
                    console.error('Error getting location:', error);
                });
            } else {
                console.error('Geolocation is not supported by this browser.');
            }
        },
        select(){
            this.$emit('selectMapCoordinateHandle',{
                lat:this.clickedLocation.lat,
                lng:this.clickedLocation.lng
            })
            this.clickedLocation = null
            this.hide()
        }
    },
};
</script>
<style scoped>
.w-80 {
    width: 80%;
}
.map-view{
    width: 100%;
    height: 80vh;
}
.vue-map-container{
    width: 100% !important;
    height: 100% !important;
}
@media (max-width: 768px) {
    .map-view{
        height: 60vh;
    }
    .title{
        font-size: 1rem;
    }
}
</style>